module.exports = __webpack_public_path__ + "static/img/f2.7831a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f2.png
// module id = bKD9
// module chunks = 1